import { useState } from "react";
import { Plus, Minus } from "lucide-react";

/**
 * Accessible FAQ accordion. Renders an array of { q, a } items.
 * Pair this with FAQPage JSON-LD (useJsonLd → buildFaqSchema) for SEO.
 */
const FAQAccordion = ({ faqs = [], idPrefix = "faq" }) => {
  const [open, setOpen] = useState(0);
  if (!faqs.length) return null;
  return (
    <div className="divide-y divide-[#D9D9D9] rounded-2xl border border-[#D9D9D9] bg-white overflow-hidden" data-testid={`${idPrefix}-accordion`}>
      {faqs.map((f, i) => {
        const isOpen = open === i;
        return (
          <div key={f.q} data-testid={`${idPrefix}-item-${i}`}>
            <button
              type="button"
              onClick={() => setOpen(isOpen ? -1 : i)}
              className="w-full flex items-center justify-between gap-3 px-5 py-4 text-left hover:bg-[#FAFAF7] transition-colors"
              aria-expanded={isOpen}
            >
              <span className="text-base font-semibold text-[#1F2A44]">{f.q}</span>
              {isOpen
                ? <Minus className="w-4 h-4 text-[#C8A96B] flex-shrink-0" />
                : <Plus  className="w-4 h-4 text-[#C8A96B] flex-shrink-0" />}
            </button>
            {isOpen && (
              <div className="px-5 pb-4 text-sm text-[#333333]/80 leading-relaxed">
                {f.a}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default FAQAccordion;
